/* eslint-disable no-param-reassign */
import React, { Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Table } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import H3FormInput from '@Uilib/h3FormInput';
import H3Text from '@Uilib/h3Text';
import { DEFAULT_CUR_ROUND_OFF, QUANTITY } from '@Apis/constants';
import ProductFilterV2 from '@Components/Common/ProductFilterV2';
import Helpers from '@Apis/helpers';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import QuickAddButton from '@Components/Common/UILib/QuickAddButton';
import ProductDescriptions from '@Components/Common/ProductDescriptions';
import BatchSelector from '@Components/Inventory/Indent/CreateIndent/BatchSelector';
import RecentTransactions from '../../../../Inventory/ManageProducts/ViewProduct/RecentTransactions';
import ProductCategoryLabel from '../../../../Common/ProductCategoryLabel';
import './style.scss';

/**
 *
 */
const PsLines = ({
  data, loading, title, handleProductChangeValue, handleProductChange, formSubmitted, addNewRow, tenantDepartmentId, updateData, handleDelete, user, tenantId, selectedCustomer, cfPackingSlipLine, allStock, toggleAllStock, visibleColumns, customLineInputChange, isFromSalesOrder, toggleBatch, toggleBatchInner, handleQuantityChange, updateBatchValue, isCarryForward, cfV2DocPackingSlip, handleMultiProductChange,
}) => {
  const getColumns = () => {
    const productListColumns = [
      {
        title: 'Product',
        fixed: 'left',
        width: '250px',
        render: (text, record) => (
          <div style={{ minWidth: '250px', maxWidth: '250px' }}>
            {record?.product_sku_info
              ? (
                <div className="ps-table__product-name">
                  <div className="flex-display">
                    <div>
                      <Link to={`/inventory/product/view/${record?.product_sku_info?.product_sku_id}`} target="_blank">
                        {`#${record?.product_sku_info?.internal_sku_code}`}
                      </Link>
                      <div>
                        {record?.product_sku_name}
                      </div>
                    </div>
                    {/* <div className="margin-left-auto">
                      {Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.CREATE, user) && (
                        <RecentTransactions
                          tenantId={tenantId}
                          productSkuId={record?.product_sku_info?.product_sku_id}
                          internalSkuCode={record?.product_sku_info?.internal_sku_code}
                          refProductCode={record?.product_sku_info?.ref_product_code}
                          productSkuName={record?.product_sku_name}
                          costumerID={selectedCustomer}
                          TransactionType="SALES_ORDER"
                        />
                      )}
                    </div> */}
                  </div>
                  {record?.product_category_info?.category_path?.length > 0 && (
                    <ProductCategoryLabel
                      categoryPath={record?.product_category_info?.category_path}
                      categoryName={record?.product_category_info?.category_path?.at(-1)}
                      containerStyle={{
                        width: 'fit-content',
                      }}
                    />
                  )}

                  {
                    !record?.remarkRequired
                    && (
                      <QuickAddButton
                        label="Add Description"
                        onClick={() => {
                          const copyData = JSON.parse(JSON.stringify(data));
                          const newData = copyData.map((item) => {
                            if (item.key === record.key) {
                              return { ...item, remarkRequired: !record?.remarkRequired };
                            }
                            return item;
                          });
                          if (JSON.stringify(data) !== JSON.stringify(newData)) {
                            updateData(newData);
                          }
                        }}
                      />
                    )
                  }
                  {record?.remarkRequired ? (
                    <ProductDescriptions
                      descriptions={record?.remarks}
                      modules={{
                        toolbar: false,
                      }}
                      onChange={(e) => {
                        const copyData = JSON.parse(JSON.stringify(data));
                        copyData.map((item) => {
                          if (item.key === record.key) {
                            item.remarks = e;
                            item.remarkRequired = !!e?.replace(/<[^>]+>/g, '');
                          }
                          return data;
                        });
                        updateData(copyData);
                      }}
                      className="ps-table__remarks"
                      placeholder="Add description of this item.."
                      key={record.key}
                    />
                  ) : ''}
                  <div style={{ display: 'flex' }}>
                    <div style={{ marginTop: '4px' }}>
                      {(record?.product_sku_info?.product_type === 'BUNDLE') && <H3Text text="Bundle" className="table-subscript table-subscript-tag" />}
                      {(record?.product_sku_info?.product_type === 'SERVICE') && <H3Text text="Service" className="table-subscript table-subscript-tag" />}
                    </div>
                    {record?.available_qty ? (
                      <div className="stock-value table-subscript table-subscript-tag" style={{ whiteSpace: 'nowrap' }}>
                        {`${record?.available_qty} ${record?.product_sku_info?.uom_info?.uqc?.toProperCase()}`}
                      </div>
                    ) : ''}
                  </div>
                </div>
              ) : (
                <React.Fragment>
                  <ProductFilterV2
                    record={record}
                    productTypes={['STORABLE', 'SERVICE', 'BUNDLE', 'NON_STORABLE']}
                    handleProductChangeValue={handleProductChangeValue}
                    handleProductChange={handleProductChange}
                    required
                    showError={formSubmitted && !record.product_sku_name}
                    isSalesProduct
                    onClear={(key) => {
                      const copyData = JSON.parse(JSON.stringify(data));
                      const newData = copyData.map((item) => {
                        if (item.key === key) {
                          return {
                            key: uuidv4(),
                            product_sku_name: '',
                            quantity: '',
                            batch_number: '',
                            product_batches: [],
                            packed_quantity: '',
                            product_sku_id: null,
                            product_sku_info: null,
                          };
                        }
                        return {
                          ...item,
                        };
                      });
                      addNewRow();
                      updateData(newData);
                    }}
                    excludedProducts={data.map((item) => JSON.stringify(item?.tenant_product_id)) || []}
                    disabled={!tenantDepartmentId || isFromSalesOrder}
                    tenantDepartmentId={tenantDepartmentId}
                    showClear
                    filterReservedQuantity
                    selectedTenant={tenantId}
                    enableAdvanceSearch
                    handleMultiProductChange={handleMultiProductChange}
                    loading={loading}
                  />

                </React.Fragment>
              )}
          </div>
        ),
        visible: visibleColumns?.PRODUCT?.visible,
      },
      {
        title: 'Availability',
        width: '96px',
        render: (text, record) => {
          let availableQty = 0;
          if (record?.bundle_products?.length) {
            const arr = [];
            for (let i = 0; i < record?.bundle_products?.length; i++) {
              const qty = Helpers.getValueTotalInObject(record?.bundle_products?.[i]?.product_batches?.filter((item) => (item?.batch_in_use && (allStock ? !item?.is_rejected_batch : true))), 'available_qty');
              arr.push(qty / (record?.bundle_products[i]?.quantity / (record?.quantity || 1)));
            }
            availableQty = Math.min(...arr);
          } else {
            availableQty = Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => (item?.batch_in_use && (allStock ? !item?.is_rejected_batch : true))), 'available_qty');
          }
          return (
            <div style={{ width: '80px' }}>
              {['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && '-'}
              {!['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && record?.product_sku_name
                && (
                  <Fragment>
                    {availableQty ? `${QUANTITY((availableQty / record?.uom_info?.ratio) * record?.product_sku_info?.uom_info?.ratio, (record?.uom_info?.precision || 0))} ${record?.uom_info?.uqc?.toProperCase() || ''}` : <span style={{ color: 'red', fontSize: '11px', whiteSpace: 'nowrap' }}>OUT OF STOCK</span>}
                  </Fragment>
                )}
              {!['SERVICE', 'BUNDLE'].includes(record?.product_sku_info?.product_type?.toUpperCase()) && availableQty ? (
                <H3Text
                  text={`In ${record?.product_batches?.filter((item) => item?.batch_in_use)?.length || '0'} Batches`}
                  className="table-subscript"
                />
              ) : ''}
            </div>
          );
        },
        visible: visibleColumns?.AVAILABLE_STOCK?.visible || true,
      },
      {
        title: 'Order Quantity',
        dataIndex: 'quantity',
        width: '100px',
        render: (text, record) => {
          const uqc = record?.uom_info?.uqc?.toProperCase() || '';
          const precision = record?.uom_info?.precision;
          return (
            <div style={{ width: '100px' }}>
              {`${QUANTITY(Math.abs(record?.quantity), precision)} ${uqc}`}
              {Number(record?.free_quantity) > 0 ? (
                <H3Text
                  text={`+ ${QUANTITY(record?.free_quantity || '0', record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''} Free`}
                  className="table-subscript"
                />
              ) : ''}
            </div>
          );
        },
        visible: visibleColumns?.ORDER_QUANTITY?.visible && isFromSalesOrder,
      },
      {
        title: 'Packed Quantity',
        dataIndex: 'packed_quantity',
        width: '100px',
        render: (text, record) => {
          let availableQty = 0;
          let availableBatchQty = {};
          if (record?.bundle_products?.length) {
            const arr = [];
            for (let i = 0; i < record?.bundle_products?.length; i++) {
              const qty = Helpers.getValueTotalInObject(record?.bundle_products?.[i]?.product_batches?.filter((item) => item?.batch_in_use), 'available_qty');
              arr.push(qty / (record?.bundle_products[i]?.quantity / (record?.quantity || 1)));
            }
            availableQty = Math.min(...arr);
          } else {
            availableQty = Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => (item?.batch_in_use && (allStock ? !item?.is_rejected_batch : true))), 'available_qty');
            availableQty = QUANTITY((availableQty / record?.uom_info?.ratio) * record?.product_sku_info?.uom_info?.ratio, (record?.uom_info?.precision || 0));
            const getEntries = (obj) => (obj ? Object.entries(obj) : []);
            const staticReservations = JSON.parse(sessionStorage.getItem('staticReservations'));
            const batchIdsToSum = record?.product_batches?.filter((item) => (item?.batch_in_use && (allStock ? !item?.is_rejected_batch : true)))?.map((item) => item?.batch_id) || [];
            const valuesToSum = batchIdsToSum?.flatMap((batchId) => getEntries(staticReservations[batchId])
              .filter(([lineId, value]) => lineId !== record?.key)
              .map(([lineId, value]) => value));
            const sum = valuesToSum.reduce((acc, value) => acc + value, 0);
            availableBatchQty = availableQty - sum;
          }
          return (
            <div style={{ width: '120px' }}>
              <div className="ps-qty-input">
                <H3FormInput
                  value={record.packed_quantity}
                  type="number"
                  containerClassName={`orgInputContainer ${(formSubmitted && Number(record.packed_quantity) <= 0) ? 'create-ps__input' : ''}`}
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  onChange={(e) => {
                    const updatedData = data.map((item) => {
                      if (item.key === record.key) {
                        const fieldValue = e.target.value;
                        item.packed_quantity = fieldValue > 0 ? parseFloat(Number(fieldValue || 0).toFixed(DEFAULT_CUR_ROUND_OFF)) : '';
                      }
                      return item;
                    });
                    updateData(updatedData);
                    customLineInputChange();
                    handleQuantityChange(record, e.target.value, record.packed_free_quantity || 0, false);
                  }}
                />
                <div className="ps-qty-input-uom">{record?.uom_info?.uqc?.toProperCase()}</div>
              </div>
              {record?.product_sku_info && Number(record?.free_quantity) > 0 && !user?.tenant_info?.inventory_config?.settings?.enable_batch_consumed_qty_editable && (
                <div className="freebie-container">
                  <div
                    className="freebie-cta"
                    onClick={(e) => {
                      const copyData = JSON.parse(JSON.stringify(data));
                      copyData.map((item) => {
                        if (item.key === record.key) {
                          item.showFreebie = true;
                        }
                        return data;
                      });
                      updateData(copyData);
                    }}
                  >
                    + Add Free Qty
                  </div>
                  {record?.showFreebie && (
                    <div className="freebie-input">
                      <H3FormInput
                        value={record.packed_free_quantity}
                        type="number"
                        containerClassName={`orgInputContainer ${(formSubmitted && Number(record.packed_free_quantity) < 0) ? 'form-error__input' : ''}`}
                        labelClassName="orgFormLabel"
                        inputClassName="orgFormInput"
                        onChange={(e) => {
                          handleQuantityChange(record, record.packed_quantity, e.target.value, record?.showFreebie);
                        }}
                      />
                      <CloseOutlined onClick={() => {
                        handleQuantityChange(record, record.packed_quantity || 0, 0, false);
                      }}
                      />
                    </div>
                  )}
                </div>
              )}
              {record?.product_sku_info && (
                <Fragment>
                  {!['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type)
                    && (record?.bundle_products?.length ? (Number(availableQty || 0) - (Number(record?.packed_quantity) + Number(record?.packed_free_quantity || 0))) < 0 : (Number(availableBatchQty) - (Number(record?.packed_quantity) + Number(record?.packed_free_quantity || 0)) < 0 || availableQty === 0))
                    ? (
                      <div className="input-error">
                        *Entered quantity is more than available quantity
                      </div>
                    ) : (
                      <Fragment>
                        {['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && formSubmitted
                          && (Number(availableQty + record?.packed_quantity) < 0)
                          ? (
                            <div className="input-error">
                              Sufficient inventory is not available.
                            </div>
                          ) : ''}
                      </Fragment>
                    )}
                </Fragment>
              )}

            </div>
          );
        },
        visible: visibleColumns?.PACKED_QUANTITY?.visible,
      },
      {
        title: '',
        width: '40px',
        fixed: 'right',
        render: (text, record) => (
          <Fragment>
            {data.length !== record.key && (
              <div className="update-ps__delete-line-button" onClick={() => handleDelete(record.key)}>
                <CloseOutlined />
              </div>
            )}
          </Fragment>
        ),
        visible: true,
      },

    ];
    if (cfPackingSlipLine?.length) {
      productListColumns.splice(4, 0, ...CustomFieldHelpers.renderCustomLineColumns(false, cfPackingSlipLine, visibleColumns, customLineInputChange, formSubmitted, '', '', '', '', '', '', '', isCarryForward));
    }

    return productListColumns.filter((item) => item.visible);
  };

  const bundleListColumns = [
    {
      title: 'SKU#',
      render: (record) => (
        <Link to={`/inventory/product/view/${record?.product_sku_info?.product_sku_id}`} target="_blank">
          {record?.product_sku_info?.internal_sku_code}
        </Link>
      ),
    },
    {
      title: 'PRODUCT',
      width: '300px',
      render: (text, record) => (
        <div className="ps-table__product-name">
          {record?.product_sku_info?.product_sku_name}
        </div>
      ),
    },
    {
      title: 'Availability',
      width: '80px',
      render: (text, record) => {
        const availableQty = Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => item?.batch_in_use), 'available_qty');
        return (
          <Fragment>
            {['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && '-'}
            {!['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && record?.product_sku_name
              && (
                <Fragment>
                  {availableQty ? `${QUANTITY((availableQty / record?.uom_info?.ratio) * record?.product_sku_info?.uom_info?.ratio, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase()}` : <span style={{ color: 'red', fontSize: '11px', whiteSpace: 'nowrap' }}>OUT OF STOCK</span>}
                </Fragment>
              )}
            {!['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => item?.batch_in_use), 'available_qty') ? (
              <H3Text
                text={`In ${record?.product_batches?.filter((item) => item?.batch_in_use)?.length || '0'} Batches`}
                className="table-subscript"
              />
            ) : ''}
          </Fragment>
        );
      },
    },
    {
      title: 'QUANTITY',
      dataIndex: 'quantity',
      width: '120px',
      render: (text, record) => (
        <div>
          {`${Helpers.getValueTotalInObject(record?.product_batches, 'consumed_qty')} ${record?.uom_info?.uqc?.toProperCase()}`}
        </div>
      ),
    },

  ];

  const getBundleLineKeys = (rows) => {
    const keys = [];
    for (let i = 0; i < rows?.length; i++) {
      if (rows[i]?.bundle_products?.length) {
        keys.push(rows[i]?.key);
      }
    }
    return keys;
  };

  return (
    <div className="ps-lines__wrapper">
      <Table
        title={title}
        bordered
        loading={loading}
        showHeader
        size="small"
        scroll={{ x: 'max-content' }}
        columns={getColumns()}
        dataSource={data}
        pagination={false}
        expandable={{
          rowExpandable: (record) => (record?.bundle_products || Helpers.getValueTotalInObject(record?.product_batches, 'available_qty')) && !['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type),
          defaultExpandedRowKeys: getBundleLineKeys(data),
          expandedRowRender: (record) => (
            <Fragment>
              {record.bundle_products?.length ? (
                <div className="inv__bundle-products__wrapper">
                  <Table
                    bordered
                    loading={loading}
                    showHeader
                    size="small"
                    columns={bundleListColumns}
                    dataSource={record?.bundle_products}
                    pagination={false}
                    expandable={{
                      defaultExpandAllRows: false,
                      rowExpandable: (innerRecord) => innerRecord?.product_sku_name && Helpers.getValueTotalInObject(innerRecord?.product_batches, 'available_qty'),
                      expandedRowRender: (innerRecord) => (
                        <BatchSelector
                          innerBatchSelector
                          batchMethod={innerRecord?.batchConsumptionMethod}
                          updateBatchConsumptionMethod={(value) => {
                            const copyData = JSON.parse(JSON.stringify(data));
                            const sortedData = copyData?.map((item) => {
                              if (innerRecord.key === item.key) {
                                item.batchConsumptionMethod = value;
                                item.product_batches = Helpers.batchSelectionMethod(value, item.product_batches, item.quantity, allStock, null, item?.uom_info);
                              }
                              return {
                                ...item,
                              };
                            });
                            updateData(sortedData);
                          }}
                          batches={innerRecord?.product_batches}
                          uomInfo={innerRecord?.uom_info}
                          productUomInfo={innerRecord?.product_sku_info?.uom_info}
                          expiryDays={innerRecord?.product_sku_info?.expiry_days}
                          itemsRow={innerRecord}
                          onToggleBatch={(batch, adjustmentRow) => toggleBatchInner(batch, adjustmentRow)}
                          productInfo={innerRecord}
                        />
                      ),
                    }}
                    scroll={{ x: 'max-content' }}
                  />
                </div>
              ) : (
                <BatchSelector
                  allStock={allStock}
                  upDateAllStock={() => {
                    const copyData = JSON.parse(JSON.stringify(data));
                    const filteredData = copyData?.map((item) => {
                      if (record?.key === item?.key) {
                        for (let i = 0; i < item?.product_batches?.length; i++) {
                          item.product_batches[i].consumed_qty = 0;
                        }
                        item.packed_quantity = 0;
                      }
                      return {
                        ...item,
                      };
                    });
                    updateData(filteredData);
                    toggleAllStock();
                  }}
                  batchMethod={record?.batchConsumptionMethod}
                  updateBatchConsumptionMethod={(value) => {
                    const copyData = JSON.parse(JSON.stringify(data));
                    const sortedData = copyData?.map((item) => {
                      if (record.key === item.key) {
                        item.batchConsumptionMethod = value;
                        item.product_batches = Helpers.batchSelectionMethod(value, item.product_batches, item.packed_quantity, allStock, null, item?.uom_info);
                        item.free_quantity = 0;
                      }
                      return {
                        ...item,
                      };
                    });
                    updateData(sortedData);
                  }}
                  batches={record?.product_batches}
                  uomInfo={record?.uom_info}
                  productUomInfo={record?.product_sku_info?.uom_info}
                  expiryDays={record?.product_sku_info?.expiry_days}
                  itemsRow={record}
                  onToggleBatch={(batch, adjustmentRow) => toggleBatch(batch, adjustmentRow)}
                  productInfo={record}
                  updateBatchValue={(value, label, batchId) => updateBatchValue(record, value, label, batchId)}
                  noBlockCalculation
                />
              )}
            </Fragment>
          ),
        }}
      />
    </div>
  );
};

/**
 *
 * @param UserReducers
 * @param PurchaseOrderReducers
 * @return {{updateCustomPurchaseOrderLoading: *, selectedPurchaseOrder, user}}
 */
const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers, OfferReducers, CFV2Reducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  updateCustomPurchaseOrderLoading: PurchaseOrderReducers.updateCustomPurchaseOrderLoading,
  selectedPurchaseOrder: PurchaseOrderReducers.selectedPurchaseOrder,
  getOfferByTenantSkuLoading: OfferReducers.getOfferByTenantSkuLoading,
});

const mapDispatchToProps = () => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PsLines));
